/**
 * Transform snake_case value from back to camelCase value
 * @param {string} snakeCaseValue
 * @returns {string}
 */
const fromSnakeToCamel = (snakeCaseValue) => {
    return snakeCaseValue
        .toLowerCase()
        .replace(/([-_][a-z])/g, (snakeCasePartToTransform) =>
            snakeCasePartToTransform.toUpperCase().replace('-', '').replace('_', ''),
        );
};
/**
 * Transform snake_case value from back to PascalCase value
 * @param {string} snakeCaseValue
 * @returns {string}
 */
const fromSnakeToPascal = (snakeCaseValue) => {
    return fromSnakeToCamel(snakeCaseValue)
        .split('_')
        .map((word, index) => {
            if (index === 0) return word.charAt(0).toUpperCase() + word.slice(1);
            return word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join('');
};
export { fromSnakeToCamel, fromSnakeToPascal };
